module.exports = __webpack_public_path__ + "static/img/zongjinglishi.e67ab54.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/zongjinglishi.png
// module id = qX6k
// module chunks = 0